// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles__panel___2a3s3","title":"styles__title___3KOMZ","description":"styles__description___3QD-Y"};